exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-cart-total table[data-v-f50b2402]{margin-bottom:0}.table-cart-total table tbody tr td[data-v-f50b2402]{background-color:#fff;font-family:Montserrat;font-size:20px;font-weight:300}.table-cart-total table tbody tr:last-of-type td[data-v-f50b2402]{font-size:20px;border-bottom:0;border-radius:0}.table-cart-total table tbody tr td[data-v-f50b2402]:last-of-type{text-align:right}.table>tbody>tr>td[data-v-f50b2402]{border:0}tr:first-child>td[data-v-f50b2402]:first-of-type{border-top-left-radius:6.79px!important}tr:first-child>td[data-v-f50b2402]:nth-of-type(2){border-top-right-radius:6.79px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f50b2402","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/TableOrder.vue
// module id = aH+3
// module chunks = 102